import { h } from 'preact';
import { useContext, useState } from 'preact/hooks';
import { KBContext } from 'widget_main/store';
import Loader from 'widget_main/components/ui/Loader';
import { getMappedLanguage } from 'i18n/helpers';
import styles from './kbArticle.scss';

const KBArticle = () => {
  const kb = useContext(KBContext);
  const [loading, setLoading] = useState(true);
  const { articles, currentArticleId } = kb;

  if (!currentArticleId) return null;

  const article = articles?.[currentArticleId];

  if (!article) return null;

  const lang = getMappedLanguage();

  return (
    <div className={styles.articleContainer}>
      {loading ? (
        <div className={styles.loaderWrapper}>
          <Loader className={styles.loader} />
        </div>
      ) : null}
      <iframe
        data-kt="kbArticleBody"
        onLoad={() => setLoading(false)}
        className={styles.articleIframe}
        title={article.title}
        src={`${kb?.config.knowledgeBaseDomain}${lang}/embed/articles/${article.slug}-${article.hash}`}
      />
    </div>
  );
};

export default KBArticle;
